import { ContentfulText } from '../common/ContentfulText';
import { FeatureCardsList } from './FeatureCardsList';

export const FeatureCardsColorMap = {
    blue: 'bg-avenue-blue-500',
    orange: 'bg-avenue-orange-500',
    [undefined]: 'bg-avenue-blue-500',
};

export function transformTextFeatureCards(featureCards) {
    return featureCards.contentLocation.map((x) => ({
        ...x,
        icon: x.icon.localFile,
        description: <ContentfulText textRichRaw={x.descriptionRich?.raw} textPlain={x.description?.description} />,
    }));
}

export function transformListFeatureCards(featureCards) {
    return featureCards.contentLocation.map((x) => ({
        ...x,
        icon: x.icon.localFile,
        description: <FeatureCardsList itemsRaw={x.descriptionRich?.raw} />,
    }));
}
